import CompanionLogo from "@assets/imgs/companion.png";

import { CompanionEstimateSection } from "./CompanionEstimate";
import { CompanionKnowledgeSection } from "./CompanionKnowledge";
import { CompanionTasksSection } from "./CompanionTasks";

export const CompanionSidebar = ({ companionSession }) => {
  if (!companionSession?.companionSessionUuid) {
    return null;
  }
  return (
    <div className="w-[30rem] bg-indigo-600 h-screen sticky top-0 p-4 flex flex-col font-companion text-md">
      <img src={CompanionLogo} width="140px" className="py-2" />
      <div className="rounded-xl bg-white flex flex-col flex-1 overflow-auto">
        <CompanionKnowledgeSection
          knowledge={companionSession?.knowledge}
        />
        <CompanionEstimateSection
          estimates={companionSession?.estimates}
        />
        <CompanionTasksSection tasks={companionSession?.tasks} />
      </div>
    </div>
  );
};
